import { defineStore } from "pinia";
import { AcademyResultsRuleType, SelectedRule } from "../../Api/competitorResultsApi";
import { translate } from "../../Common/translations";
import { Category } from "../../Common/types";
import { isIntegerBetween } from "../../Common/numbers";

//Only three places
export const BASIC_POINTS_FOR_MEDALS = { 1: 9, 2: 3, 3: 1 };
//Extended classification
export const EXTENDED_POINTS_FOR_MEDALS = { 1: 9, 2: 3, 3: 1, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0 };

export function translateRule(rule: AcademyResultsRuleType) {
    return translate(`academy_ranking_rule.${rule}`);
}

export const useAddRuleStore = defineStore("addRule", {
    /**
     * REMEMBER TO UPDATE RESET TO DEFAULTS
     */
    state() {
        return {
            eventId: 0,
            selectedRuleType: null as AcademyResultsRuleType | null,
            selectedRule: null as SelectedRule | null,
            validRule: false,

            selectedCategories: [] as Category[],

            //Rule for scoring for awarded medals
            pointsForMedals: { ...BASIC_POINTS_FOR_MEDALS } as Record<number, number>,
            excludeOneAcademy: true,
            excludeOneManCategories: true,
            useExtendedClassification: false,

            //Scoring for won matches
            pointsForWonMatch: 10,
            multiplierForSubmissionWin: 2.0 as number | null,
        };
    },
    getters: {
        selectedCategoriesArray: (state): number[] => {
            return state.selectedCategories.map(c => Number(c.key));
        },
        //TODO: Same: use for validation.
        areValidMedalPoints: state => {
            for (const key in state.pointsForMedals) {
                if (!isIntegerBetween(state.pointsForMedals[key], 0, 1000)) {
                    return false;
                }
            }
            return true;
        },
    },
    actions: {
        resetToDefaults() {
            this.selectedRuleType = null;
            this.selectedRule = null;
            this.selectedCategories = [];
            this.pointsForMedals = { ...BASIC_POINTS_FOR_MEDALS };
            this.excludeOneAcademy = true;
            this.excludeOneManCategories = true;
        },
        updatePointsForMedal(medal: number, points: string) {
            this.pointsForMedals[medal] = Number(points);
        },
        togglePointsForMedals() {
            this.pointsForMedals = this.useExtendedClassification ? EXTENDED_POINTS_FOR_MEDALS : BASIC_POINTS_FOR_MEDALS;
        },
    },
});
